// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Header-components-MainLogo----main-logo-module---container---3oK7b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/components/MainLogo/main-logo.module.less
// module id = 263
// module chunks = 114276838955818